import { useState } from '#app'

export const useSearchFlyout = () => {
  const rootOffsetTop = useState('rootOffsetTop', () => 0)

  function setRootOffsetTop(offsetTop: number) {
    rootOffsetTop.value = offsetTop
  }

  return {
    setRootOffsetTop,
    rootOffsetTop,
  }
}
